import React from 'react';
import {
  Button,
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { useStyles } from './style';
import Colors from '../Colors';

interface Data {
  details: string[];
}
interface Dropdown {
  title?: string[];
  value?: (string|number)[];
}
interface TableData {
  title?: string[];
  data?: Data[];
  collapse?: Dropdown[];
  notDetails?: boolean;
  damageForm?: damageItem[];
  sizeScreen?: number;
  customStyles?: React.CSSProperties;
}
interface damageItem {
  label: string;
  answer: string;
}

const TableRegister: React.FC<TableData> = ({
  notDetails = false,
  title,
  data,
  collapse,
  damageForm,
  sizeScreen,
  customStyles = {},
}) => {
  const styles = useStyles();
  const [damageFormColapseControl, setDamageFormColapseControl] = React.useState<boolean>(
    false,
  );
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <>
      <TableContainer component={Paper} className={styles.root} style={customStyles}>
        {' '}
        <Table aria-label="collapsible table" size="small">
          <TableHead className={styles.table}>
            <TableRow>
              {title?.map((head) => (
                <>
                  <TableCell
                    align="center"
                    width={222}
                    className={styles.tableCellHead}
                    key={`1${Math.random() * 10}${Date.now()}`}
                  >
                    {head}
                  </TableCell>
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ paddingBottom: 5, paddingTop: 0 }}>
            {data?.map((value) => (
              <>
                <TableRow
                  className={styles.tableRow}
                  key={`2${Math.random() * 10}${Date.now()}`}
                >
                  {value.details.map((detail: string) => {
                    if (
                      detail === '' ||
                      detail === 'undefined' ||
                      detail === 'null' ||
                      detail === null
                    ) {
                      return (
                        <TableCell
                          align="center"
                          width={200}
                          className={styles.tableCellBody}
                          padding="default"
                          key={`3${Math.random() * 10}${Date.now()}`}
                        >
                          Não informado
                        </TableCell>
                      );
                    }

                    return (
                      <>
                        <TableCell
                          align="center"
                          width={200}
                          className={styles.tableCellBody}
                          padding="default"
                          key={`4${Math.random() * 10}${Date.now()}`}
                        >
                          {detail}
                        </TableCell>
                      </>
                    );
                  })}
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {notDetails ? (
        <>
          <Button
            onClick={() => setOpen(!open)}
            variant="text"
            style={{ width: '70%', alignSelf: 'center' }}
          >
            {open ? (
              <>
                Fechar <KeyboardArrowUpIcon />
              </>
            ) : (
              <>
                Ver mais <KeyboardArrowDownIcon />
              </>
            )}
          </Button>
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
            style={{ width: '60%', alignSelf: 'center' }}
          >
            <Box>
              <Table size="medium">
                {collapse?.map((value) => (
                  <>
                    <TableHead
                      className={styles.rowCollapse}
                      key={`5${Math.random() * 10}${Date.now()}`}
                    >
                      <TableRow>
                        {value.title?.map((titleCollapse) => {
                          return (
                            <TableCell
                              align="center"
                              className={styles.headCollapse}
                              padding="none"
                              key={`6${Math.random() * 10}${Date.now()}`}
                            >
                              {titleCollapse}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {value.value?.map((valueCollapsed) => {
                          if (
                            valueCollapsed === '' ||
                            valueCollapsed === undefined ||
                            valueCollapsed === null
                          ) {
                            return (
                              <TableCell
                                align="center"
                                padding="default"
                                key={`7${Math.random() * 10}${Date.now()}`}
                              >
                                Não informado
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell
                              align="center"
                              padding="default"
                              key={`8${Math.random() * 10}${Date.now()}`}
                            >
                              {valueCollapsed}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableBody>
                  </>
                ))}
              </Table>
              {damageForm && (
                <>
                  {damageForm?.length > 0 ? (
                    <>
                      <Button
                        onClick={() => setDamageFormColapseControl((prev) => !prev)}
                        variant="contained"
                        style={{
                          background: Colors.secundary,
                          width: '100%',
                          margin: '5% 0 2% 0',
                          color: '#fff',
                        }}
                      >
                        Formulario de Dano
                      </Button>
                      <Collapse
                        in={damageFormColapseControl}
                        timeout="auto"
                        unmountOnExit
                        style={{
                          margin: '1rem 0',
                          alignSelf: 'center',
                          display: 'flex',
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          direction="row"
                          justify="center"
                          alignItems="center"
                          alignContent="center"
                        >
                          {damageForm.map((element) => {
                            return (
                              <div className={styles.damageForm} key={element.label}>
                                <Grid
                                  item
                                  xs={8}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                  }}
                                >
                                  {element.label}
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  {element.answer}
                                </Grid>
                              </div>
                            );
                          })}
                        </Grid>
                      </Collapse>
                    </>
                  ) : (
                    <Button
                      disabled
                      variant="contained"
                      style={{
                        opacity: '70%',
                        background: Colors.secundary,
                        width: '100%',
                        margin: '5% 0 2% 0',
                        color: '#fff',
                      }}
                    >
                      Formulario de Dano
                    </Button>
                  )}
                </>
              )}
            </Box>
          </Collapse>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default TableRegister;
